import { Icon } from "@iconify/react";
import { useRef, useState } from "react";
import trash2Outline from "@iconify/icons-eva/trash-2-outline";
import moreVerticalFill from "@iconify/icons-eva/more-vertical-fill";
import editFill from "@iconify/icons-eva/edit-fill";
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { PATH_DASHBOARD } from "routes/paths";

// ----------------------------------------------------------------------

type SessionsMoreMenuProps = {
  onDelete?: VoidFunction;
  relationshipId: string;
  sessionId: string;
};

export default function SessionsMoreMenu({
  onDelete,
  relationshipId,
  sessionId,
}: SessionsMoreMenuProps) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: "100%" },
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {Boolean(onDelete && typeof onDelete == "function") && (
          <MenuItem onClick={onDelete} sx={{ color: "text.secondary" }}>
            <ListItemIcon>
              <Icon icon={trash2Outline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText
              primary="Delete"
              primaryTypographyProps={{ variant: "body2" }}
            />
          </MenuItem>
        )}

        <MenuItem
          component={RouterLink}
          to={
            `${PATH_DASHBOARD.therapist.chineseUserRelationships.list}/${relationshipId}/edit-session/${sessionId}`
          }
          sx={{ color: "text.secondary" }}
        >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Edit"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
      </Menu>
    </>
  );
}
